module.exports = __webpack_public_path__ + "static/media/Theta Tau Logo.f7dba95a.jpeg";